module.exports = __webpack_public_path__ + "img/formsTrapezSSR.98d7be29.svg";